import { useContext } from "react";
import { CompanyContext } from "./contexts/companyCotext";
import Cookies from "js-cookie";

var host = window.location.host;
const hostloc = window.location.host;
var nameCompany = "";
if (hostloc.startsWith("localhost") || hostloc == "ishatri.com") {
  nameCompany = "Ishtari";
} else if (hostloc == "energy-plus.com" || hostloc == "energyplus-lb.com") {
  nameCompany = "Energy-Plus";
} else if (hostloc == "ishtari-usd.com") {
  nameCompany = "Ishtari-Usd";
} else if (hostloc == "flo-lebanon.com") {
  nameCompany = "Flo";
}
const _apis = {
  Ishtari: "https://www.ishtari-mobile.com/v2/index.php",
  IshtariPDO: "https://apiv2.ishtari.com/index.php",
  Issa: "https://issa.ishtari.com/api/v2/index.php",
  "Ishtari-Energy": "https://energyplus-lb.com/api/v2/index.php",
  "Ishtari-Ghana": "https://motor.ishtari.com.gh/v2/index.php",
  "Ishtari-Usd": "https://www.ishtari-usd.com/api/v2/",
  "Energy-Plus": "https://www.energyplus-lb.com/api/v2/",
  Flo: "https://flo.sari3.com/api/v2/index.php",
  "Flo-Leb": "https://api.flo-leb.com/api/v2/index.php",
  "Flo-Beirut": "https://flo.sari3.com/bey/api/v2/",
  Aalbeit: "https://www.aalbeit.com/api/v2/",
  English_Home: "https://www.englishhome.com.lb/api/v2/index.php",
  "English-Home-1": "https://www.englishhome.com.lb/store_one/api/v2/",
  "English-Home-2": "https://www.englishhome.com.lb/store_two/api/v2/",
  // 'snipex': 'https://snipextc.com/api/v2/',
};
const requests = {
  login: "?route=stockapi/admin_login",
  logout: "?route=stockapi/admin_logout",
  changeUpcQuantity: "?route=stockapi/product/changeUpcQuantity",
  orderInfo: "?route=stockapi/order",
  returnOrderInfo: "?route=stockapi/return_order",
  productsFullVersion: "?route=stockapi/products_fullversion",
  returnProductsFullVersion: "?route=stockapi/return_products_fullversion",
  transferproductsFullVersion: "?route=stockapi/transfer_products_fullversion",
  returnTransferProductsFullVersion:
    "?route=stockapi/return_transfer_products_fullversion",
  productInfo: "?route=stockapi/product",
  updateproductStatus: "?route=stockapi/product/updateStatus",
  updateQuantity: "?route=stockapi/product/updateQuantity",
  updateUPC: "?route=stockapi/product/updateUPC",
  updateBigUPC: "?route=stockapi/product/updateBigUPC",
  updateMainUPC: "?route=stockapi/product/updateMainUPC",
  updateUpcOption: "?route=stockapi/product/update_upc_option",
  updateOrder: "?route=stockapi/update_order",
  updateOrderV2: "?route=stockapi/update_order/indexV2",
  restockOrderDetails: "?route=stockapi/update_order/getOrderProductDetails",
  returnOrderDetails:
    "?route=stockapi/update_return_order/getReturnOrderProductDetails",
  updateTransfer: "?route=stockapi/update_transfer",
  getNbOfPackage: "?route=stockapi/update_order/getNbOfPackage",
  updateReturnOrder: "?route=stockapi/update_return_order",
  logistics: "?route=stockapi/logistic",
  jardeh: "?route=stockapi/jardeh",
  arrived: "?route=stockapi/return_products_fullversion/returnorderproducts",
  returnOrderProduct:
    "?route=stockapi/return_products_fullversion/returnOrderProduct",
  orderHistory: "?route=stockapi/order/getOrderHistory",
  updateReturnOrderProduct:
    "?route=stockapi/update_return_order/updateReturnOrderProductsStatus",
  getDataEntryOrder: "?route=stockapi/product_to_data_entry",
  updateProductStatus:
    "?route=stockapi/product_to_data_entry/updateProductStatus",
  restockUPC: "?route=stockapi/product/restockUpcHistory",
  checkSerialNumber: "?route=stockapi/admin_login/checkSerialNumber",
  checkSerialNumberLogOut: "?route=stockapi/admin_login/logout",
  manageUPCQty: "?route=stockapi/product/changeMinMaxUpcQuantity",
  checkProductUPCQuantity: "?route=stockapi/product/checkProductUpcQuantity",
  getMinMaxUpcQuantity: "?route=stockapi/product/getMinMaxUpcQuantity",
  checkProductDelay: "?route=stockapi/update_order/checkProductDelay",
  checkReturnProductDelay:
    "?route=stockapi/update_return_order/checkReturnProductDelay",
  jardehBatchProducts: "?route=stockapi/jardeh/batchProducts",
  jardehProducts: "?route=stockapi/jardeh/jardehProducts",
  deleteJardehProducts: "?route=stockapi/jardeh/deleteJardehProducts",
  addJardeh: "?route=stockapi/jardeh/add",
  addJardehishtari: "?route=stockapi/jardeh/add_ishtari",
  getJardehBatch: "?route=stockapi/jardeh/jardehBatches",
  deleteJardeh: "?route=stockapi/jardeh/deletejardeh",
  deleteBatch: "?route=stockapi/jardeh/deleteBatch",
  pallet: "?route=stockapi/pallet",
  getToken: "?route=token/token&grant_type=client_credentials",
  getPalletProducts: "?route=stockapi/pallet/getProductsByPallet",
  assignToPallet: "?route=stockapi/pallet/assignProductsToPallet",
  unasignFromPallet: "?route=stockapi/pallet/unassignProductsFromPallet",
  assignFloor: "?route=stockapi/pallet/assignPalletFloor",
  unassignFloor: "?route=stockapi/pallet/unassignPalletFloor",
  getBinProducts: "?route=stockapi/warehouse/getBinProducts",
  getBinInfo: "?route=stockapi/warehouse/getProductInfo",
  getWarehouseProductInfo: "?route=stockapi/warehouse/getWarehouseProductInfo",
  getTransferOrderByProduct:
    "?route=stockapi/warehouse/getTransferOrderByProduct",
  assignBin: "?route=stockapi/warehouse/addAddressToProduct",
  unassignBin: "?route=stockapi/warehouse/removeAddressFromProduct",
  updateUpcORder: "?route=stockapi/update_order/updateUpcOrder",
  updateBinORder: "?route=stockapi/update_order/updateBinOrder",
  productWarehouseDescription:
    "?route=stockapi/warehouse/getProductWarehouseHistoryV2&product_label=",
  seller_stand: "?route=stockapi/warehouse/sellerStandAction",
  updateReturnBin: "?route=stockapi/update_order/updateReturnBinOrder",
  updateTransfer: "?route=stockapi/update_transfer",
  pickupOrder: "?route=stockapi/pickup_order",
  getPickupOrders: "?route=stockapi/pickup_order/getPickupOrder",
  getPickupOrderProducts: "?route=stockapi/pickup_order/getPickupOrderProducts",
  scannLogisticsOrder:
    "?route=stockapi/logistics_order_stand/ScannLogisticsOrder",
  getPickupReturnOrderProducts:
    "?route=stockapi/pickup_order/getPickupReturnOrderProducts",
  checkShelfLabel: "?route=stockapi/pickup_order/checkShelfLabel",
  pickupOrderProduct: "?route=stockapi/pickup_order/pickupOrderProductV2",
  missingPickupOrderProduct:
    "?route=stockapi/pickup_order/missingPickupOrderProduct",
  restockOrder: "?route=stockapi/update_order/changeOrderProductStatus",
  returnOrderStatus:
    "?route=stockapi/update_return_order/changeReturnOrderProductStatus",
  pickupReturnOrderProduct:
    "?route=stockapi/pickup_order/pickupReturnOrderProductV2",
  missingPickupReturnOrderProduct:
    "?route=stockapi/pickup_order/missingPickupReturnOrderProduct",
  assignProductToBin: "?route=stockapi/warehouse/assignProductToBin",
  ctn_labeling: "?route=stockapi/ctn_labeling/ctnScannCode",
  assignWarehouseProductToBin:
    "?route=stockapi/warehouse/assignWarehouseProductToBin",
  unassignProductFromBin: "?route=stockapi/warehouse/unassignProductFromBin",
  unassignWarehouseProductFromBin:
    "?route=stockapi/warehouse/unassignWarehouseProductFromBin",
  receivedProductQty: "?route=stockapi/product/receiveProductQuantity",
  getProductHistory: "?route=stockapi/product/getProductHistory",
  restockBigUpc: "?route=stockapi/product/restockBigUpcHistory",
  graphPage: "?route=stockapi/user_profile",
  getReceivedProducts: "?route=stockapi/warehouse/getReceivedProducts",
  getWarehouseProductDetails:
    "?route=stockapi/warehouse/getWarehouseProductDetails",
  updateReference: "?route=stockapi/warehouse/updateReference",
  checkProduct: "?route=stockapi/warehouse/checkProductSerialNumber",
  getTransfer: "?route=stockapi/update_transfer/getTransfer",
  pickTransferProducts: "?route=stockapi/update_transfer/pickTransferProducts",
  returnReasonforProduct:
    "?route=stockapi/update_return_order/getReturnOrderProductInfo",
  refillProduct: "?route=stockapi/product/refillProduct",
  updateBin: "?route=stockapi/warehouse/changeProductBin",
  getproductsinwarehouse:
    "?route=stockapi/warehouse/getWarehouseQuantyByProduct",
  fetchtowarehouse: "?route=stockapi/warehouse/getAllWarehouses",
  fromwarehouse: "?route=stockapi/warehouse/getAllowedWarehousesByWarehouse",
  fetchfromwarehouse: "?route=stockapi/warehouse/getAllWarehouses",
  fetchReceivedWarehouseProducts: "?route=stockapi/warehouse/getAllWarehouses",
  getTransferOrderByIdStudio:
    "?route=stockapi/warehouse/getTransferOrderByIdStudio",
  getProductAddressStudio: "?route=stockapi/warehouse/getProductAddressStudio",
  restockStudioGhana: "?route=stockapi/warehouse/restockStudioGhana",
  towarehouse: "?route=stockapi/warehouse/getAllowedWarehousesByWarehouse",
  submitwarehousechange: "?route=stockapi/warehouse/transferWarehouseProducts",
  changeWarehouseProductBin:
    "?route=stockapi/warehouse/changeWarehouseProductBin",
  getTransferOrderById: "?route=stockapi/warehouse/getTransferOrderById",
  getTransferOrderProducts:
    "?route=stockapi/warehouse/getTransferOrderProducts",
  changeProductStatus: "?route=stockapi/warehouse/changeProductStatus",
  getFloors: "?route=stockapi/pickup_order/getPickupOrdersFloors&user_id=",
  getFloorProducts: "?route=stockapi/pickup_order/getPickupFloorAllProducts",
  sortingFloorProducts: "?route=stockapi/pickup_order/sortingFloorProducts",
  getSellerStandHistory:
    "?route=stockapi/warehouse/getSellerStandHistory&product_label=",
  getProductPallet: "?route=stockapi/update_order/getProductPallet",
  assignProductToPallet: "?route=stockapi/update_order/assignProductToPallet",
  restockProductFromPallet:
    "?route=stockapi/update_order/restockProductFromPallet",
  getDrivers: "?route=stockapi/logistic/drivers",
  getLowStockProducts: "?route=stockapi/product_low_stock",
  checkLowStockProduct: "?route=stockapi/product_low_stock/checkedProduct",
  changeLowStockProductAddress:
    "?route=stockapi/warehouse/changeWarehouseProductBin",
  checkOrderType: "?route=stockapi/order/checkOrderType",
  addJardehMissingDimensions: "?route=stockapi/jardeh/updateProductAttributes",
  updateBinV2: "?route=stockapi/update_order/updateBinOrderV2",
  updateReturnBinV2: "?route=stockapi/update_order/updateReturnBinOrderV2",
  updateReturnOrderV2: "?route=stockapi/update_return_order/indexV2",
  scannLogisticsOrderV2:
    "?route=stockapi/logistics_order_stand/ScannLogisticsOrderV2",
  restockOrderDetailsV2:
    "?route=stockapi/update_order/getOrderProductDetailsV2",
  returnOrderDetailsV2:
    "?route=stockapi/update_return_order/getReturnOrderProductDetailsV2",
};

let storeParams = "";
function buildLink(link, payload, width) {
  var apiUrl = "";
  if (
    host.startsWith("localhost") ||
    host === "pda.ishtari.com" ||
    host === "test-pda.sari3.com" ||
    host === "next.ishtari.com.gh"
  ) {
    const testCookie = Cookies.get("testpdo");

    apiUrl = testCookie == "true" ? _apis["IshtariPDO"] : _apis["Ishtari"];
  } else if (host == "pda.ishtari.com.gh") {
    apiUrl = _apis["Ishtari-Ghana"];
  } else if (host === "pda.energyplus-lb.com") {
    apiUrl = _apis["Ishtari-Energy"];
  } else if (host == "issa-pda.ishtari.com") {
    apiUrl = _apis["Issa"];
  } else if (host === "flo-pda.sari3.com") {
    apiUrl = _apis["Flo"];
    const store = localStorage.getItem("store_id");

    storeParams = store == null ? "" : `&store_id=${store}`;
  } else if (host === "pda.flo-leb.com") {
    apiUrl = _apis["Flo-Leb"];
    const store = localStorage.getItem("store_id");

    storeParams = store == null ? "" : `&store_id=${store}`;
  } else if (host === "pda.englishhome.com.lb") {
    apiUrl = _apis["English_Home"];
    const store = localStorage.getItem("store_id");

    storeParams = store ? `&store_id=${store}` : "";
  }

  const extra_params = typeof payload == "undefined" ? "" : payload;
  return `${apiUrl}` + requests[link] + extra_params + storeParams;
}
export default buildLink;
